module.exports = __webpack_public_path__ + "static/media/0@3x.911d3cd9.png";